<template>
  <div id="app">
    <!-- <router-view /> -->
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="isRouterAlive"
      include="FortuneInfo,FortuneComment"
    />
  </div>
</template>

<script>
import common from "@/common/apihost.js";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      active: 0,
    };
  },
  created() {
    // this.index();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 页面刷新使用方法
    /*
    data(){},
    inject:["reload"],
    //调用
    this.reload()
    */

  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  font-size: 0.24rem;
  height: 100%;
}
.container-backr {
  min-height: 100%;
}
.van-nav-bar--fixed {
  z-index: 999;
}
.van-nav-bar__content {
  height: 0.88rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue